// Marks Quick Order List rows as out-of-stock when data indicates
// stock <= 0 and max = 0 (i.e., not "continue selling" items).
// No changes to discount logic; independent of your pricing JS.

(() => {
  const TABLE_SEL = '.quick-order-list__table';
  const ROW_SEL = 'tr.variant-row';
  const INPUT_SEL = 'input.quick-order-list__quantity-input';

  function isOutOfStock(row) {
    const input = row.querySelector(INPUT_SEL);
    if (!input) return false;

    // Use both signals to avoid flagging "continue selling" cases:
    const stock = Number(input.getAttribute('data-stock') || '0');
    const max = input.getAttribute('max');
    const maxNum = max === null ? null : Number(max);

    // OOS when we explicitly see zero stock AND max is 0 (cannot add)
    const oos = (stock <= 0) && (maxNum === 0);
    return !!oos;
  }

  function applyOOSState(row, oos) {
    if (oos) {
      if (!row.classList.contains('qol-oos')) {
        row.classList.add('qol-oos');
        row.setAttribute('aria-disabled', 'true');

        // Add banner to the "size-stock" cell (exists in your markup)
        const stockCell = row.querySelector('.size-stock') || row.querySelector('td');
        if (stockCell && !stockCell.querySelector('.qol-oos-banner')) {
          const banner = document.createElement('div');
          banner.className = 'qol-oos-banner';
          banner.textContent = 'Out of stock';
          stockCell.appendChild(banner);
        }
      }
    } else {
      row.classList.remove('qol-oos');
      row.removeAttribute('aria-disabled');
      const banner = row.querySelector('.qol-oos-banner');
      if (banner) banner.remove();
    }
  }

  function scanAndMark() {
    const table = document.querySelector(TABLE_SEL);
    if (!table) return;
    const rows = table.querySelectorAll(ROW_SEL);
    rows.forEach(row => applyOOSState(row, isOutOfStock(row)));
  }

  // Initial scan
  document.addEventListener('DOMContentLoaded', scanAndMark);

  // Re-scan if the table content updates dynamically (theme scripts, filters, etc.)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.addedNodes && m.addedNodes.length) {
        scanAndMark();
        break;
      }
      if (m.attributeName === 'max' || m.attributeName === 'data-stock') {
        scanAndMark();
        break;
      }
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const table = document.querySelector(TABLE_SEL);
    if (!table) return;
    mo.observe(table, { subtree: true, childList: true, attributes: true, attributeFilter: ['max', 'data-stock'] });
  });
})();
